<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrlNo" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem v-for="(c, i) in formCtrlOrder" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 控件后组件 -->
              <div class="switch">
                <el-switch v-model="istime" active-color="#67C23A" :class="istime ? 'active' : 'inactive'"
                  @change="toggleSwitch">
                </el-switch>
                <div class="txt">结款提醒</div>
              </div>
            </template>
          </FormItem>
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import nonOrderViewMixin from "./nonOrderViewMixin";

export default {
  mixins: [detailMixin, nonOrderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "订单管理", path: "/order/nocontract" },
        { name: "普通订单", path: "/order/nocontract/own/done" },
        { name: "订单添加" },
      ],
      form: {
        inton: undefined,
        unton: undefined,
      },
      rules: {
        inton: [
          { required: true, validator: this.checkInTon, trigger: "blur" },
        ],
        unton: [
          { required: true, validator: this.checkUnTon, trigger: "blur" },
        ],
      },
      // 运单信息
      formCtrlOrder: [
        {
          label: "公司单价（元/吨）",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "司机单价（元/吨）",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货重量（吨）",
          keyName: "inton",
          err: "请填写装货重量",
          type: "text",
        },
        {
          label: "卸货重量（吨）",
          keyName: "unton",
          err: "请填写卸货重量",
          type: "text",
          className: "unton",
        },
        {
          label: "装货单",
          keyName: "invoice",
          err: "请填写装货单",
          type: "file",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请填写卸货单",
          type: "file",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          className: "unton",
        },
        // {
        //   label: "亏吨协议单价",
        //   keyName: "unitprice",
        //   err: "请填写亏吨协议单价",
        //   type: "number",
        //   viewMode: true,
        // },
        // {
        //   label: "亏吨协议重量",
        //   keyName: "unitton",
        //   err: "请填写亏吨协议重量",
        //   type: "number",
        //   viewMode: true,
        // },
        {
          label: "计算重量（吨）",
          keyName: "caton",
          err: "请填写计算重量",
          type: "text",
          tips: "不填写则默认卸货重量为计算重量！",
        },
        {
          label: "亏吨重量（吨）",
          keyName: "kuiton",
          err: "请填写亏吨重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "公司承担亏吨重量（吨）",
          keyName: "ceton",
          err: "请填写公司承担亏吨重量",
          type: "number",
          tips: "不填写则默认亏吨重量为计算重量！",
        },
        {
          label: "亏吨单价（元/吨）",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写则默认亏吨的钱不算到运费！",
        },
        // {
        //   label: "实际公司承担亏吨",
        //   keyName: "dceton",
        //   err: "请填写实际公司承担亏吨",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费！",
        // },
        // {
        //   label: "实际亏吨单价（元/吨）",
        //   keyName: "dtonprices",
        //   err: "请填写实际亏吨单价",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费！",
        // },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
